import OLSourceVector from 'ol/source/Vector'

import type { ConfigLayerOptions } from './ConfigLayer'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import GeoJSONIO from 'data/geojsonio'
import { unzip } from 'utils/zip'

// Loader for Annotation layer
// Take the annotation param from URL (now stored in model), unzip it and add as
// features
//
// TEST URL:
// http://localhost:3000/#/site[next]/x[144.65510]/y[-38.27138]/z[17]/annotation[eyJ0eXBlIjoiRmVhdHVyZUNvbGxlY3Rpb24iLCJmxIrEjMSOc8SGW8SAxILEhMSGxIjEnsSNxIXEm3Byb8SEcsSWZcShOsSAc3TErmtlLWPEkW9yxKcjMDA2MmIxxJoixLfEucS7xK9hY2nEgsSGMcSbxYtvxLotd2lkdGjEhjPEm2ZpxJLEvMS%2BxYDEh8WCxYTFhsWIxaHFo2wtxY7FkMWSOjAuxZQibWFyxLpyLXN5bWLEkcSnxZByY8STIn3Em2dlb21lxLh5xIbEpMSDxIXEh1BvaW50xYnEvcS%2FZMaaxIvEs8SiMTQ0LjY1MjA1Nzg2NzczNjjFoC0zOC4yxrQ1Njkwxq85xrQxN119xorGlMSmxIfEicSLxKrFicStxK9lxLFpxqPEtcWKxLjFl8S7xL1sxL%2FFgcWDxYXFh8WJxZbFmMWxxZHGkjrFt8ejxLvFmsWcxZ46xaDEnMWuxaXHnMWnIsWpx6DFrMexxaTHpcWzxbXFt8W5xbvHksW%2BxoDGgmzGhGnGhsaIxooixozGjsaQcsenx4nGliLGmMaaxpzEm8aecsagbsaixLRbxqXGp8apNcijOTc1OMaxODksxrfGuca7ODE5x4QxNTkzOTQ2x4bHiMSBxpXEp8eMxJ%2FEqyLHkMSwxLLEtMS2x5jFmMebx53FqMefxavHosmJxY1wxY%2FHpsWTxZXJkcWZxZvFncWfxa3FpMmLx7XHt8mPyZ3Fr8e8x6fHvsSbyIDFvMiDxoHGg8SHxoXGh8SFyIvIjcaPxpHGk8i9x4rIlMaZxpvGnW%2FGn8ahdMeVyJ%2FGpsaoyKPGvjcwyLIwMjM3yKzGuMa6xr7IsseDyKfKizDHhceHx4Y%3D]/tab[tools]/

export default function (layerConf: ConfigLayerOptions) {
  // console.debug('LoaderAnnotation', layerConf?.titleid, layerConf)

  const source = new OLSourceVector()

  const fcZippedB64 = Model.getState('annotation', null)
  if (fcZippedB64) {
    // console.debug('LoaderAnnotation - fcZippedB64', fcZippedB64)

    let fcObj

    try {
      const fcStrAgain = unzip(fcZippedB64)
      fcObj = JSON.parse(fcStrAgain)
    } catch (error) {
      console.log('Failed to unzip string', layerConf.titleid, error, fcZippedB64)

      return null
    }

    const olFeaturesArr = PoziUtils.convertGeoJSONFeatureCollectionToOLFeatureArray(fcObj)

    // Style every individual feature based on its properties
    source.on('addfeature', (evt) => {
      console.debug('LoaderAnnotation - addfeature', layerConf.titleid, layerConf)

      const feature = evt.feature

      if (!feature) {
        console.log('LoaderAnnotation - addfeature - no feature', evt)
        return
      }

      // Get the actual OL style from geosjonio.js. We use a fake layerConf
      // to tell geojsonio what the labelProp field is.
      const layerPropConf = { styleGeoJSONIO: { labelProp: 'label' } }
      const style = GeoJSONIO().getStyle(layerPropConf, feature)
      feature.setStyle(style)
    })

    source.addFeatures(olFeaturesArr)
  }

  return source
}
